import { create } from 'zustand';

export interface AppError {
  id: string;
  title: string;
  description: string;
  messages?: string[];
  isValidationError?: boolean;
  action?: string;
  referenceId: string;
  requestId?: string;
  backendTraceId?: string;
  timestamp: string;
}

interface ErrorStore {
  errors: AppError[];
  addError: (title: string, description: string, action?: string) => string;
  addErrorWithId: (
    referenceId: string,
    title: string,
    description: string,
    action?: string,
    messages?: string[],
    isValidationError?: boolean,
    requestId?: string,
    backendTraceId?: string,
  ) => string;
  removeError: (id: string) => void;
  clearAll: () => void;
}

export function generateReferenceId(): string {
  const hex = Math.floor(Math.random() * 0xFFFFFF).toString(16).toUpperCase().padStart(6, '0');
  const ts = Date.now().toString(36).toUpperCase().slice(-3);
  return `${ts}${hex}`;
}

export const useErrorStore = create<ErrorStore>((set) => ({
  errors: [],

  addError: (title, description, action) => {
    const referenceId = generateReferenceId();
    const id = crypto.randomUUID();
    const error: AppError = { id, title, description, action, referenceId, timestamp: new Date().toISOString() };
    set((state) => ({ errors: [...state.errors, error] }));
    return referenceId;
  },

  addErrorWithId: (referenceId, title, description, action, messages, isValidationError, requestId, backendTraceId) => {
    const id = crypto.randomUUID();
    const error: AppError = {
      id, title, description, action, messages, isValidationError,
      requestId, backendTraceId,
      referenceId, timestamp: new Date().toISOString(),
    };
    set((state) => ({ errors: [...state.errors, error] }));
    return referenceId;
  },

  removeError: (id) =>
    set((state) => ({ errors: state.errors.filter((e) => e.id !== id) })),

  clearAll: () => set({ errors: [] }),
}));